var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import throttle from 'lodash.throttle';
import Title from '../../atoms/Title';
import CtaBtn from '../../atoms/CtaBtn';
import { hanghae, neutralDay, scc } from '@teamsparta/design-system';
import CtaTextContainer from '../../molecules/CtaTextContainer';
import CtaText from '../../atoms/CtaText';
import { VerticalGap } from '../../atoms/Gap/Gap';
import Input from '../../atoms/Input';
import { checkEmail, checkPassword } from '../../../businessLogics';
import AlertText from '../../atoms/AlertText';
import { emailAtom, PUSH, readWriteModalHistoryAtom, Tasks } from '../../../stores';
import { useAtom } from 'jotai';
import { BottomContents, MainContents } from '../../../styles/_common.style';
import styled from '@emotion/styled';
import { useIsMobile, useQueryStringParams } from '../../../businessLogics/hooks';
import { Device } from '../../../styles/_variables';
import { useLoginEmail } from '../../../businessLogics/apis';
import { formatDate } from '../../../businessLogics/_utils';
var LoginEmail = function (_a) {
    var setIsShow = _a.setIsShow, nextPage = _a.nextPage, CPLogger = _a.CPLogger;
    var _b = useAtom(readWriteModalHistoryAtom), updateHistory = _b[1];
    var _c = useAtom(emailAtom), email = _c[0], setEmail = _c[1];
    var _d = useState(''), password = _d[0], setPassword = _d[1];
    var _e = useState(null), emailWarning = _e[0], setEmailWarning = _e[1];
    var _f = useState(null), passwordWarning = _f[0], setPasswordWarning = _f[1];
    var isMobile = useIsMobile();
    var loginEmail = useLoginEmail(setIsShow, setEmailWarning, setPasswordWarning, CPLogger, nextPage);
    var query = useQueryStringParams();
    var login = function () {
        if (checkEmail(email, setEmailWarning) && checkPassword(password, setPasswordWarning))
            loginEmail.mutate({ email: email, password: password });
    };
    var throttledLogin = useCallback(throttle(login, 200, { trailing: false }), [email, password]);
    useEffect(function () {
        if (query.get('login_v2_email')) {
            var email_1 = query.get('login_v2_email');
            var createdAt = query.get('login_v2_email_created_at');
            setEmail(email_1);
            setEmailWarning("\uC774\uBA54\uC77C\uB85C \uAC00\uC785\uD55C \uACC4\uC815\uC774 \uC788\uC2B5\uB2C8\uB2E4. (\uAC00\uC785\uC77C: ".concat(formatDate(createdAt), ")"));
            query.delete('login_v2_email');
            query.delete('login_v2_email_created_at');
        }
    }, [query.get('login_v2_email')]);
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 70 }, { children: [_jsx(Title, { children: "\uC774\uBA54\uC77C \uB85C\uADF8\uC778" }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsx(Input, { value: email, setValue: setEmail, placeHolder: '이메일 입력', defaultValue: email, onClickCta: throttledLogin }), _jsx(AlertText, __assign({ isShow: !!emailWarning, color: hanghae.red100 }, { children: emailWarning })), _jsx(VerticalGap, { size: 12 }), _jsx(Input, { value: password, setValue: setPassword, placeHolder: '비밀번호 입력', type: 'password', onClickCta: throttledLogin }), _jsx(AlertText, __assign({ isShow: !!passwordWarning, color: hanghae.red100 }, { children: passwordWarning })), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: throttledLogin }, { children: "\uB85C\uADF8\uC778" }))] }))] })), _jsxs(BottomContents, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: throttledLogin }, { children: "\uB85C\uADF8\uC778" })), _jsx(VerticalGap, { size: 24 })] })), _jsxs(CtaTextContainer, { children: [_jsx(CtaText, { text: '회원가입', color: neutralDay.gray70, onClickAction: function () {
                                    updateHistory({ action: PUSH, task: Tasks.SIGNUP_EMAIL });
                                } }), _jsx(Divider, {}), _jsx(CtaText, { text: '이메일 찾기', color: neutralDay.gray70, onClickAction: function () {
                                    updateHistory({ action: PUSH, task: Tasks.FIND_EMAIL_INITIAL });
                                } }), _jsx(Divider, {}), _jsx(CtaText, { text: '비밀번호 찾기', color: neutralDay.gray70, onClickAction: function () {
                                    updateHistory({ action: PUSH, task: Tasks.CHANGE_PASSWORD_INITIAL });
                                } })] })] })] }));
};
export default LoginEmail;
var Divider = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1px;\n  height: 16px;\n  background: ", ";\n  margin: 0 22px;\n\n  ", " {\n  }\n"], ["\n  width: 1px;\n  height: 16px;\n  background: ", ";\n  margin: 0 22px;\n\n  ", " {\n  }\n"])), neutralDay.gray30, Device.Mobile);
var templateObject_1;
//# sourceMappingURL=LoginEmail.js.map